import React from 'react'
import { useHistory } from 'react-router-dom'

import usStateAll from '../Map/usStatesAll'

import styles from './SearchPopover.module.scss'

const SearchPopoverStateItems = React.forwardRef(
  ({ criteria, onAdd, searchText, visible: isVisible, entity }, ref) => {
    const history = useHistory()

    const filteredStates = usStateAll.filter((state) => {
      if (
        (state.label &&
          state.label.toLowerCase().includes(searchText.toLowerCase())) ||
        state.value.toLowerCase().includes(searchText.toLowerCase())
      ) {
        return state
      } else {
        return null
      }
    })
    const slicedFilteredStates = filteredStates.slice(0, 10)

    return (
      <>
        <li
          data-option
          key={'state'}
          onClick={() => {}}
          onKeyDown={(event) => {
            const { key, currentTarget } = event
            const next = key === 'ArrowDown'
            const prev = key === 'ArrowUp'

            if (!next && !prev) return

            event.preventDefault()

            const nextFocus =
              currentTarget[
                next ? 'nextElementSibling' : 'previousElementSibling'
              ]

            if (nextFocus) nextFocus.focus()
          }}
          tabIndex={-1}
          className={styles.title}
        >
          <b>States</b> <br />
          <span className={styles.showing}>
            (Showing{' '}
            {Math.min(filteredStates.length, slicedFilteredStates.length)} of{' '}
            {filteredStates.length} matching your search criteria)
          </span>
        </li>
        {slicedFilteredStates.map((option) => (
          <li
            data-option
            key={option.value}
            onClick={() => history.push(`/forecasts/${entity}StateDashboard/state/${option.value}`)}
            onKeyDown={(event) => {
              const { key, currentTarget } = event
              const next = key === 'ArrowDown'
              const prev = key === 'ArrowUp'

              if (!next && !prev) return

              event.preventDefault()

              const nextFocus =
                currentTarget[
                  next ? 'nextElementSibling' : 'previousElementSibling'
                ]

              if (nextFocus) nextFocus.focus()
            }}
            onKeyPress={({ key }) =>
              key === 'Enter' &&
              history.push(`/forecasts/${entity}StateDashboard/state/${option.value}`)
            }
            tabIndex={-1}
          >
            <span>
              {option.label} ({option.value})
            </span>
          </li>
        ))}
      </>
    )
  }
)
export default SearchPopoverStateItems
